(function(){
    angular.module('tmx-app').service('AddressGeographyService', ['tmxResource','tmxUtility','$q',

        function lookupService(tmxResource,tmxUtility,$q){
  
            var service=this;
            var returnObject ={};
            var resource=tmxResource("AddressGeography");
  //Custom functions for resources
            resource.getCountriesAndStates=function(){
                var geoService=this;
                return geoService.getByAction('GetCountriesAndStates',true);
            }
            resource.getCitiesByState=function(stateId){
                var geoService=this;
                return geoService.getByAction('AddressGeographyCascade/City/'+stateId,true);
            }

            resource.getParent=function(cityId){
                var geoService=this;
                return geoService.getByAction('GetParent/'+cityId,false);
            }


            service.getLookups=function(){
                var deferred=$q.defer();
                var success=function(){
                    deferred.resolve(returnObject);
                }
                if(!angular.isDefined(returnObject.lookups)){
                    getLookupsFromServer(resource,returnObject,tmxUtility,onBasisOfParent,success);
                }
                else success();
                return deferred.promise;
            }

            service.getCountries=function(){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(
                    function(result){
                        var countries=result.lookups.getById("Countries");
                        deferred.resolve(countries);
                    }
                );
                return deferred.promise;
            }

            service.getStatesByCountryId=function(countryId){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(
                    function(result){
                        var states=result.lookups.getById(countryId);
                        deferred.resolve(states);
                    }
                );
                return deferred.promise;
            }

            service.getCitiesByStateId=function(stateId){
                return resource.getCitiesByState(stateId);
            }

            service.getParentById=function(cityId){
                return resource.getParent(cityId);
            }
        }]);

    function getLookupsFromServer(service,resultHolder,tmxUtility,groupBasis,success){
        service.getCountriesAndStates().then(
            function(response){// Get all lookups
                resultHolder.lookups=groupResources(tmxUtility,response.data,groupBasis);//Save their local copy after grouping them by type
/*          resultHolder.lookups.registerId(306,"Country");
          resultHolder.lookups.registerId(307,"State");*/
                success();
            }
        );
    }

    function groupResources(tmxUtility,allResources,onBasisOf){
        var groups=tmxUtility.groupBy(allResources,onBasisOf);
        return groups;
    }

    // eslint-disable-next-line no-unused-vars
    function onBasisOfGeoType(obj){
        return obj.GeographyTypeLkp;
    }

    function onBasisOfParent(obj){
        if(!angular.isDefined(obj.ParentGeographyId) || obj.ParentGeographyId===null) return "Countries";

        return obj.ParentGeographyId;
    }

})();